'use client'

import { isVillageData } from '@utils/house'
import ShowCaseListings from './listings'
import ShowCaseVillage from './village'

export default function ShowCase({
  data,
  showMap = false,
  className = '',
  onMouseEnter,
  onMouseLeave
}) {

  if (isVillageData(data)) {
    return (
      <ShowCaseVillage
        data={data}
        showMap={showMap}
        className={className}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    )
  }

  return (
    <ShowCaseListings
      data={data}
      showMap={showMap}
      className={className}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  )
}
